module.exports = __webpack_public_path__ + "static/media/CancelPolicy.c1a2f818.svg";